import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-story-tutorial',
  templateUrl: './story-tutorial.component.html',
  styleUrls: ['./story-tutorial.component.scss']
})
export class StoryTutorialComponent implements OnInit {

  constructor() { }

  @Input() headingImage: string;

  @Input() headingText: string;

  @Input() paragraphText: string;

  @Input() primaryButtonText: string

  @Input() secondaryButtonText: string;

  @Input() youText: string;

  @Input() storyTutorialStep: number;
  @Input() centerImage: string;

  @Input() userStoryList = [];

  @Input() introducingText = '';

  @Input() storiesText = ''

  @Input() newText: string;

  @Output() emitNextStep: EventEmitter<number> = new EventEmitter();
  public customOptionsForStoriesList: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    center: false,
    navSpeed: 90,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    responsive: {
      0: {
        items: 3,
        navSpeed: 900
      },
      400: {
        items: 3,
        navSpeed: 900
      },
      600: {
        items: 3
      },
      940: {
        items: 3
      }
    },
    nav: true,
    margin: 14,
    // navigation: true,
    autoplay: false,
    autoHeight: true,
    autoWidth: true
  };

  @Output() emitHidden: EventEmitter<void> = new EventEmitter();
  /**
   * hidding pop up
   */
  onHidden(): void {
    console.log("hidden")
    this.emitHidden.emit();
  }

  /**
   * Necessary instances.
   */
  trackByFn(index: any, item: any): any {
    return item;
  }
  /**
   * emit next step event 
   */
  nextStep(): void {
    this.emitNextStep.emit(this.storyTutorialStep + 1);
  }
  /**
   * emit next step event 
   */
  previousStep(): void {
    this.emitNextStep.emit(this.storyTutorialStep - 1);
  }

  ngOnInit(): void {
    this.emitNextStep.emit(0)
  }

}
